import { isPlainObject } from 'lodash';
import { DATA_BINDING } from '@wix/app-definition-ids';
import { filterResolverKey as RESOLVER_KEY } from '@wix/wix-data-client-common-standalone';
const RESOLVER_VALUE = DATA_BINDING;
export const addDataBindingResolver = (filterExpression) => Object.assign({}, filterExpression, { [RESOLVER_KEY]: RESOLVER_VALUE });
export const shouldResolveDataBinding = (filterExpression) => isPlainObject(filterExpression) &&
    filterExpression[RESOLVER_KEY] === RESOLVER_VALUE;
//# sourceMappingURL=dataBindingFilterResolver.js.map